import React, { useState } from 'react';
import { BottomSheet } from '../ui/BottomSheet';
import { Switch } from '../ui/Switch';
interface AddTaskSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (input: {
    title: string;
    deadline: string;
    reminder: boolean;
  }) => void;
}
function getDefaultDate(): string {
  return new Date().toISOString().slice(0, 10);
}
export function AddTaskSheet({
  isOpen,
  onClose,
  onSubmit
}: AddTaskSheetProps) {
  const [title, setTitle] = useState('');
  const [date, setDate] = useState(getDefaultDate());
  const [time, setTime] = useState('09:00');
  const [reminder, setReminder] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = title.trim();
    if (!trimmed || !date) return;
    const deadline = new Date(`${date}T${time || '09:00'}`).toISOString();
    onSubmit({
      title: trimmed,
      deadline,
      reminder
    });
    setTitle('');
    setDate(getDefaultDate());
    setTime('09:00');
    setReminder(false);
    onClose();
  };
  return <BottomSheet isOpen={isOpen} onClose={onClose} title="New task" data-id="element-103" data-mp="2wf7eqwyyn1e4">
      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-104" data-mp="31chfh8rsuzh9">
        <div data-id="element-105" data-mp="31awk5gxnvcic">
          <label htmlFor="task-title" className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-106" data-mp="35em5lxj1hdz5">
            Task
          </label>
          <input id="task-title" type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="e.g. Submit expense report" autoFocus className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100" data-id="element-107" data-mp="3a5kl4uw7e81c" />
        </div>
        <div className="flex gap-3" data-id="element-108" data-mp="3t1uaieck2l0n">
          <div className="flex-1" data-id="element-109" data-mp="1upc3r7prgji3">
            <label htmlFor="task-date" className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-110" data-mp="1uq533nme46q7">
              Due date
            </label>
            <input id="task-date" type="date" value={date} onChange={e => setDate(e.target.value)} className="w-full rounded-xl border border-slate-200 px-3 py-3 text-sm text-slate-900 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100" data-id="element-111" data-mp="320tcycnz1t11" />
          </div>
          <div className="flex-1" data-id="element-112" data-mp="36yuv8vdkpobg">
            <label htmlFor="task-time" className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-113" data-mp="3kzntnr6zx3ju">
              Time
            </label>
            <input id="task-time" type="time" value={time} onChange={e => setTime(e.target.value)} className="w-full rounded-xl border border-slate-200 px-3 py-3 text-sm text-slate-900 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100" data-id="element-114" data-mp="3g01gfhr63nb1" />
          </div>
        </div>
        <div className="flex items-center justify-between rounded-xl bg-slate-50 px-4 py-3" data-id="element-115" data-mp="2mpmp0bsdag6">
          <div data-id="element-116" data-mp="m77xuaq419u8">
            <p className="text-sm font-medium text-slate-700" data-id="element-117" data-mp="m8risempo92c">Remind me</p>
            <p className="text-xs text-slate-400" data-id="element-118" data-mp="r7ck6hdp8ysd">Flag this task so it stands out</p>
          </div>
          <Switch checked={reminder} onChange={setReminder} activeColorClassName="bg-indigo-600" label="Toggle reminder" data-id="element-119" data-mp="d7kxls94aa2r" />
        </div>
        <button type="submit" disabled={!title.trim()} className="w-full rounded-xl bg-indigo-600 py-3 text-sm font-semibold text-white transition-colors duration-150 hover:bg-indigo-700 disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-400" data-id="element-120" data-mp="h724mq46zfa1">
          Add task
        </button>
      </form>
    </BottomSheet>;
}